import React, { Component } from 'react';
import { connect } from "react-redux";

import VehicleCell from '../Pages/Stakeholder/Vehicle/VehicleCell';
import ProfileCell from '../Pages/Stakeholder/User/ProfileCell';
import BookingDateAndTime from '../Common/Blocks/BookingDateAndTime';
import {constants} from "../../Helpers/Constants";

import axios from "axios";
import moment from "moment";
import ReminderActionsComponent from './ReminderActionsComponent.jsx';
import { VCIcon, DivisionIcon } from '../Common/Buttons/TypeIcons.js';

//A React component will allow us to quickly iterate and change our code. It provides 
class VehicleReminderRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
    }

    render() {
        return (
            <div className = "alert-row">
                <div className = "float-left">
                    {
                        this.props.reminder.vehicle.Photos != '' ?
                            <img className = "alert-row-image" src={'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_' + this.props.reminder.vehicle.Photos} />
                        :
                            <img className = "alert-row-image" src={this.props.settings.images.vehicle_placeholder_square} />
                    }
                </div>
                <div className = "float-left">
                    <span className = "medium">{this.props.reminder.vehicle.Year} {this.props.reminder.vehicle.Make} {this.props.reminder.vehicle.Model}</span>, { constants.reminder_options[this.props.reminder.Category] }
                    <div className = "clearfix"></div>
                    <span className = "yellow-warning">{"" + (this.props.reminder.Remind_Date != null ? moment(this.props.reminder.Remind_Date).format("MMM D, YYYY") : "") + (this.props.reminder.Remind_Date != null && this.props.reminder.Remind_km != null ? " | " : "") + (this.props.reminder.Remind_km != null ? this.props.reminder.Remind_km + " KM" : "")}</span>
                </div>
                <div style={{padding:'8px 6px'}} className = "float-left clearfix">
                    {VCIcon(this.props.reminder.vehicle.vmh, undefined, undefined, undefined, true)}
                    {DivisionIcon(this.props.reminder.vehicle.stakeholder, undefined, undefined, undefined, true)}
                </div>
                {
                    this.props.reminder.has_booking ? 
                        <div className = "alert-actions">
                            <ReminderActionsComponent match={this.props.match} history={this.props.history} datatoggle={this.props.datatoggle} id={this.props.reminder.REMIND_ID} V_ID={this.props.reminder.vehicle.V_ID}/>
                        </div>
                    :
                        <span />
                }
                <div className = "clearfix"></div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings
});

export default connect(mapStateToProps)(VehicleReminderRow);